const enviroment = {
  apiUrl: 'https://webapi-qa.credex.com.ni',
  remittancesAPI: 'https://apicash-qa.credex.com.ni/',
  sentryDSN:
    'https://0e32411c87e6e581a3475cd0195a0b3c@o4507986424496128.ingest.us.sentry.io/4507987014451200',
}

export default enviroment
